module.exports = __webpack_public_path__ + "img/square_to_disavow_delivery.715f12c0.svg";